import api from './api';

export const getCalculatorTypes = () => api.get('/design/calculator-types');

export const calculate = (calculatorType, inputs) =>
  api.post(`/design/calculate/${calculatorType}`, inputs);

export const createCalculation = (data) => api.post('/design/calculations', data);

export const getCalculations = (params = {}) => api.get('/design/calculations', { params });

export const getCalculation = (id) => api.get(`/design/calculations/${id}`);

export const reviewCalculation = (id, decision, reviewedById, reviewNotes) =>
  api.put(`/design/calculations/${id}/review`, {
    decision,
    reviewed_by_id: reviewedById,
    review_notes: reviewNotes,
  });

export const deleteCalculation = (id) => api.delete(`/design/calculations/${id}`);

export const getProjectDesignSummary = (projectId, approvedOnly = false) =>
  api.get(`/design/projects/${projectId}/summary`, { params: approvedOnly ? { approved_only: true } : {} });

export const downloadProjectDesignSummaryPdf = (projectId, approvedOnly = false) =>
  api.get(`/design/projects/${projectId}/summary.pdf`, {
    params: approvedOnly ? { approved_only: true } : {},
    responseType: 'blob',
  });

export const downloadTankDesignReportPdf = (calculationId, reportMetadata) =>
  api.post(`/design/calculations/${calculationId}/tank-design-report.pdf`, reportMetadata, {
    responseType: 'blob',
  });
